<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <style>
    #header {
      position: relative;
      z-index: 99;
    }

    #header .logo {

      background-position: left;
      background-repeat: no-repeat;
      background-size: contain;
      width: 125px;
      height: 75px;
    }

    #content {
      opacity: 0;
      min-height: calc(100vh - 170px);
    }

    #content.show {
      opacity: 1;
      transition: opacity 0.3s;
    }

    #content:not(.show) {
      height: calc(100vh - 170px);
    }

    #footer {
      padding: 20px 0 18px;
      background-color: #e4001c;
      color: #fff;
    }

    #footer .row {
      display: flex;
      align-items: center;
    }

    #footer .social-links {
      text-align: right;
    }

    #footer .social-links a {
      display: inline-block;
      margin-left: 10px;
      color: #e40001;
      font-size: 24px;
      border-radius: 50%;
      background-color: #fff;
      width: 36px;
      height: 36px;
      text-align: center;
    }

    #preloader {
      z-index: 9999;
      /* greater than pikaday */
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      /* background-image: url(res/images/preloader.gif); */
      background-position: center;
      background-repeat: no-repeat;
      display: none;
    }


    @media screen and (max-width: 767px) {
      #content {
        min-height: calc(100vh - 260px);
      }

      #content:not(.show) {
        height: calc(100vh - 260px);
      }

      #footer {
        padding: 10px 0;
        text-align: center;
      }

      #footer .row {
        display: block;
      }

      #footer .row>div {
        padding: 5px 0;
      }

      #footer .social-links {
        text-align: center;
      }


    }

    body {
      font-family: Barlow-Regular;
      font-size: 13px;
      overflow-x: hidden;
      width: 100%;
      letter-spacing: 1px;
    }

    p {
      font-family: bahnschrift;
    }

    a,
    a:hover {
      color: inherit;
    }

    .pd-0 {
      padding: 0 !important;
    }

    .pd-left-0 {
      padding-left: 0 !important;
    }

    .pd-right-0 {
      padding-right: 0 !important;
    }

    .mg-0 {
      margin: 0 !important;
    }

    .navbar-toggle .icon-bar {
      background-color: black;
    }

    .nav>li>a:focus,
    .nav>li>a:hover {
      text-decoration: none;
      background-color: transparent !important;
    }

    .navbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #000;
      border: 0;
    }

    /* .text-light .navbar {
    color: #fff !important;
} */
    .navbar .hamburger {
      display: none;
      font-size: 24px;
      user-select: none;
    }

    .navbar input[type=checkbox] {
      display: none;
    }

    .navbar .menu {
      display: flex;
      gap: 1em;
      font-size: 18px;
    }

    .nav-links {
      list-style: none;
      display: flex;
      align-items: center;
      margin: 0;
      padding: 0;
      gap: 1rem;
    }

    .navbar .menu li {
      list-style: none;
    }

    .navbar .hotline {
      font-size: 23px;
      padding-right: 30px;
    }

    .navbar .hotline img {
      width: 35px;
      padding-right: 2px;
      filter: brightness(0) saturate(100%) invert(0%) sepia(45%) saturate(6688%) hue-rotate(241deg) brightness(104%) contrast(111%);
    }

    a.nav-link {
      color: #000;
      text-decoration: none;
      font-size: 12px;
      font-family: bahnschrift;
      margin: 0;
      text-transform: uppercase;
    }

    a.nav-link:hover {
      text-decoration: none;
    }

    .navbar-toggle .icon-bar {
      display: block;
      width: 25px;
      height: 4px;
      border-radius: 1px;
    }

    button.navbar-toggle {
      position: absolute;
      right: 0;
      top: 10px;
    }


    .fix-wrapper {
      width: 92%;
      margin: 0 auto;
      max-width: 1440px;
    }

    .small-wrapper {
      max-width: 650px;
    }

    .round-input {
      display: block;
      width: 100%;
      padding: 6px 12px;
      line-height: 1.5;
      color: #555;
      background-color: #f5f5f5;
      background-image: none;
      /*border: 0;*/
      outline: none;
      border-radius: 40px;
    }

    .round-input::placeholder {
      color: #9e9e9e;
    }

    .round-input:disabled {
      background-color: #eee;
    }

    .round-input:focus {
      box-shadow: 0 0 2px 2px #e40001;
    }

    .has-error .round-input {
      box-shadow: 0 0 2px 2px #e40001;
      background-color: #ffebee;
    }

    .btn-round {
      color: #fff;
      background-color: #e4001c;
      padding: 6px 22px;
      border: 0;
      cursor: pointer;
      display: inline-block;
      margin-right: 10px;
      font-weight: 700;
      letter-spacing: 1px;
      text-decoration: none;
    }

    .btn-round:last-child {
      margin-right: 0;
    }

    .btn-round:hover,
    .btn-round:focus {
      background-color: #c62828;
      color: #fff;
      outline: 0;
    }

    .btn-round.btn-default {
      color: #000;
      background-color: #eee;
    }

    .btn-round.btn-default:hover,
    .btn-round.btn-default:focus {
      background-color: #9E9E9E;
    }

    .btn-full {
      width: 100%;
    }

    .btn-lg {
      padding: 12px 30px 11px;
      font-size: 16px;
    }

    .btn-xs {
      padding: 2px 5px 3px;
      font-size: 13px;
    }

    .spacing-top {
      margin-top: 3rem;
    }

    .order-tabs.nav {
      border: none;
    }

    .order-tabs.nav>li>a {
      border: 0;
      border-radius: 0;
      padding: 0;
      color: #777;
    }

    .order-tabs.nav>li>a:hover {
      border: 0;
      color: inherit;
      background: transparent;
    }

    .order-tabs.nav>li.disabled>a:hover {
      color: #777;
    }

    .order-tabs.nav>li:nth-child(2)>a {
      margin: 0 15px;
      padding: 0 15px;
      border-left: 1px solid #424242;
      border-right: 1px solid #424242;
    }

    .order-tabs.nav>li.active>a {
      color: #e40001;
      font-weight: 700;
      border: 0;
    }

    .tab-content .tab-pane .tab-pane-content {
      padding: 15px 0;
      text-align: center;
    }

    .bg-grey {
      background-color: #f5f5f5;
      /* height: 100vh; 100% of screen height */
    }

    .text-danger {
      font-weight: 700;
      font-size: 18px;
      color: #f44336;
    }

    .text-success {
      font-weight: 700;
      font-size: 18px;
      color: #4caf50;
    }

    .text-require {
      color: #e40001;
    }

    .text-white {
      color: #fff !important;
    }

    .swiper-container {
      width: 100%;
      height: 100%;
    }

    .swiper-container .swiper-slide {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    .swiper-container .swiper-pagination .swiper-pagination-bullet-active {
      background: #f5f5f5;
    }

    .swiper-button {
      opacity: 0.4;
    }

    .swiper-button:hover,
    .swiper-button:focus {
      opacity: 0.8;
    }

    .swiper-container .swiper-wrapper {
      margin: 0 auto;
    }

    h1 {
      font-family: BarlowCondensed-SemiBold;
    }

    .main-banner {
      height: 450px;
      position: relative;
      overflow: hidden;
      text-align: center;
    }

    .main-banner .swiper-slide {
      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: top;
    }

    .request-wrapper .square-gap {
      font-size: 14px;
      margin: 0 5px;
      color: #e4001c;
    }

    .request-content .quote-icon {
      height: 150px;
      width: auto;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: bottom;
      margin: 0 auto;
    }

    .request-content .request-content-1 .quote-icon {
      width: 165px;
    }

    .request-content .request-content-3 .quote-icon {
      width: 110px;
    }

    .request-content h1 {
      font-family: 'Barlow-Regular';
      letter-spacing: 5px;
    }

    .request-content p {
      color: #fff;
      margin: 0;
    }

    .centered {
      padding: 0 20px;
      position: absolute;
      top: 52%;
      left: 30%;
      transform: translate(-50%, -50%);
      width: 45%;
      text-align: left;
    }

    .centered h1 {
      font-size: 50px;
      font-family: 'Barlow-Bold';
      letter-spacing: 3px;
    }

    .centered p {
      font-size: 20px;
      font-family: 'Barlow-Bold';
      letter-spacing: 2px;
      margin: 0;
    }

    .special-service {
      background: #E5262D;
      padding: 100px 0;
    }

    .special-service-box label {
      font-size: 12px;
      font-family: bahnschrift;
      text-align: center;
      letter-spacing: 1.5px;
      color: white;
      margin-top: 10px;
      opacity: 80%;
    }


    .service,
    .product {
      padding: 3.5rem 0;
    }

    .product {
      background-color: #eee;
    }

    .service-content .square-gap {
      font-size: 30px;
      line-height: 1px;
      color: #e4001c;
    }

    .service-content h2,
    .product-content h2 {
      font-size: 30px;
      font-family: barlow-bold;
      margin-bottom: 2rem;
    }

    .service-box-center {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .service-box-center img {
      max-width: 75%;
    }

    .service-box-left {
      text-align: right;
      margin-bottom: 3rem;
    }

    .service-box-right {
      text-align: left;
      margin-bottom: 3rem;
    }

    .service-box h3,
    .product-content h3 {
      font-size: 21px;
      font-family: 'barlow-medium' !important;
      letter-spacing: 2px;
      color: #626262;
      text-decoration: none;
      line-height: 1.2;
      margin-top: 10px;
      margin-bottom: 0;
    }

    .service-content-2 p {
      font-size: 16px;
      font-family: 'barlow-medium' !important;
      letter-spacing: 1px;
      color: #626262;
      text-decoration: none;
      line-height: 1.2;
      margin-top: 30px;
    }

    .service-box p,
    .service-box label,
    .product-content p {
      opacity: 90%;
      font-size: 13px;
      font-family: 'barlow-regular';
      letter-spacing: 1px;
      color: #626262;
      text-decoration: none;
      line-height: 1.5;
      margin: 10px 0 30px;
    }

    .service-box-left img,
    .service-box-right img {
      max-width: 15%;
    }

    .product-card {
      position: relative;
      box-shadow: 0 2px 7px #dfdfdf;
      margin: 10px auto;
      background: #fafafa;
    }

    .product-tumb {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
    }

    .product-tumb img {
      width: 100%;
      height: 100%;
    }

    .product-details {
      padding: 30px;
    }

    .product-details .read-more {
      border: 1px solid black;
      padding: 5px 15px;
      background: transparent;
      border-radius: 20px;
      letter-spacing: 1.2px;
      margin-top: 2rem;
      margin-bottom: 2rem;
      opacity: 80%;
      font-size: 20px;
    }

    .product-details .read-more.red {
      color: #fff;
      background-color: #e4001c;
      border: 0;
    }


    .strike {
      display: block;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      width: 220px;
      margin: 0 auto;
    }

    .strike>span {
      position: relative;
      display: inline-block;
      font-size: 26px;
      font-weight: 500;
      color: white;
    }

    .strike>span:before,
    .strike>span:after {
      content: "";
      position: absolute;
      top: 52%;
      width: 9999px;
      border-bottom: 2px solid white;
    }

    .strike>span:before {
      right: 80%;
    }

    .strike>span:after {
      left: 80%;
    }

    @media (max-width: 767px) {
      .main-banner {
        height: 400px;
      }



      .centered {
        top: 62%;
        width: 235px;
        color: white;
        background: #e4001cdb;
        padding: 0 20px 20px;
        border-radius: 20px;
      }

      .centered h1 {
        font-size: 23px;
      }

      .centered p {
        font-size: 13px;
      }

      .main-banner .centered .text-require {
        color: #fff;
      }

      .request-wrapper h1 {
        font-size: 28px;
      }

      .request-wrapper h3 {
        font-size: 14px;
      }

      .request-content .quote-icon {
        height: 75px;
      }

      .request-content .request-content-1 .quote-icon {
        width: 120px;
      }

      .request-content .request-content-3 .quote-icon {
        width: 80px;
      }

      .request-content {
        display: -webkit-flex;
        /* Safari */
        display: flex;
        flex-flow: wrap;
      }

      /* .request-content-1{
        order: 2;
		margin-top: 3rem;
    }
    .request-content-2{
        order: 1;
    }
    .request-content-3{
        order: 3;
		margin-top: 3rem;
    } */
      .request-content h1 {
        font-size: 25px;
      }

      .request-content p {
        font-size: 12px;
      }


      .step-line .line {
        width: 150px;
        height: 50px;
        border-left: 2px solid white;
        border-bottom: 0;
        position: absolute;
        left: 50%
      }

      .service-box-center img {
        max-width: 45%;
      }

      .service-box h3,
      .product-content h3,
      .news-content h3,
      .location-content h3,
      .contact-content h3,
      .towing-content h3 {
        font-size: 18px;
        font-family: barlow-semibold;
        letter-spacing: 2.0px;
        margin-top: 10px;
      }

      .service-box p,
      .product-content p,
      .news-content p,
      .location-content p,
      .contact-content p,
      div input::placeholder,
      div textarea::placeholder,
      .fpx-content p {
        font-size: 12px;
        font-family: bahnschrift;
        text-align: center;
        letter-spacing: 1.2px;

      }

      .service-content-1 {
        order: 2;
        margin-top: 3rem;
      }

      .service-content-2 {
        order: 1;
      }

      .service-content-3 {
        order: 3;
      }

      .service-box-left,
      .service-box-right {
        text-align: center !important;
        margin-bottom: 3rem;
      }
    }

    @media (max-width: 576px) {
      .centered {
        left: 38%;
      }
    }

    @media (min-width: 768px) {
      .service-box__height {
        height: 360px;
      }
    }

    @media (max-width: 991px) {
      .navbar .hamburger {
        display: block;
        margin-left: 130px;
      }

      .navbar .menu {
        display: none;
        position: absolute;
        background: rgb(0 0 0 / 100%);
        right: 0;
        left: 0;
        text-align: center;
        padding: 16px 0;
        top: 85px;
      }

      .navbar .menu li:hover {
        display: inline-block;
        transition: 0.3s ease;
      }

      .navbar .menu li+li {
        margin-top: 12px;
      }

      .navbar input[type=checkbox]:checked~.menu {
        display: block;
      }

      .navbar input[type=checkbox]:checked~.menu a.nav-link {
        color: #fff;
      }

      .navbar .hotline {
        font-size: 18px;
        padding-right: 0;
      }

      .navbar .hotline img {
        width: 26px;
      }
    }


    @media only screen and (min-device-width: 768px) and (max-device-width: 1023px) {

      .centered {
        width: 40%;
      }

      .request-content {
        display: -webkit-flex;
        /* Safari */
        display: flex;
        flex-flow: wrap;
      }

      .service-box-center {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 250px !important;
      }

      .service-box-left,
      .service-box-right {
        text-align: center !important;
      }

      .service-box-left h3,
      .service-box-right h3 {
        font-size: 18px;
        font-family: 'barlow-medium';
        letter-spacing: 2.5px;
        color: #626262;
        text-decoration: none;
        line-height: 1.2;
        margin-top: 10px;
        margin-bottom: 0;
      }

      .service-box-left label,
      .service-box-right label {
        opacity: 80%;
        font-size: 11px;
        font-family: 'barlow-regular';
        letter-spacing: 2px;
        color: #626262;
        text-decoration: none;
        line-height: 1.2;
        margin-top: 10px;
        margin-bottom: 0;
      }

      .service-box__height {
        height: 600px;
      }


    }

    .centered {
      width: 35%;
    }


    #order {
      overflow: hidden;
      position: relative;
      padding-top: 20px;
    }

    #order .text-line-through {
      text-decoration: line-through;
    }

    #stepAdjust .collapse-wrapper,
    #stepAdjust .panel-order {
      text-align: left;
      padding: 0 18px;
      border-radius: 12px;
      background-color: #fff;
      margin-bottom: 20px;
    }

    #stepAdjust .collapse-wrapper .btn-toggle,
    #stepAdjust .panel-order .panel-heading {
      text-align: center;
      display: block;
      padding: 10px 0;
      font-size: 15px;
    }

    #stepAdjust .panel-order .btn-toggle {
      padding: 8px;
      display: block;
    }

    #stepAdjust .btn-toggle .fa {
      float: right;
      margin: 4px 4px 0 0;
    }

    #stepAdjust .collapse-wrapper .collapse-panel .panel {
      border: 0;
      box-shadow: none;
      margin: 0;
    }

    #stepAdjust .collapse-wrapper .collapse-panel .panel .panel-body {
      border-top: 2px solid #e40001;
      padding: 15px 0;
    }

    #stepAdjust .panel-order>.panel-heading {
      border-bottom: 2px solid #e40001;
    }

    #stepAdjust .panel-order .collapse-panel .panel-body {
      padding: 10px;
      background-color: #eee;
    }

    #stepAdjust .panel-order table th:nth-child(2),
    #stepAdjust .panel-order table td:nth-child(2) {
      text-align: right;
    }

    #stepAdjust .panel-order table tr.sep th {
      background-color: #e40001;
      color: #fff;
    }

    #stepAdjust .panel-order table tr.tr-collapse form .radio {
      margin-top: 0;
    }

    #stepAdjust .panel-order table tr.tr-collapse form .radio label {
      font-weight: 700;
      margin-bottom: 5px;
    }

    #stepAdjust .panel-order table tr.tr-collapse form .radio .note {
      margin: 0 0 0 20px;
      font-size: 12px;
    }

    #stepAdjust .panel-order table tr.tr-collapse>td {
      padding: 0;
      border-top: 0;
    }

    #stepAdjust .panel-order table tr.sep th {
      background: #da1e00;
      color: #fff;
    }

    #stepAdjust .panel-order table tfoot {
      font-size: 18px;
    }

    #stepAdjust [readonly] {
      background-color: #fff;
    }

    #stepAdjust select[name="coverType"] {
      text-transform: capitalize;
    }

    #stepAdjust select[name="roadtaxMonth"] {
      display: inline-block;
      width: auto;
    }

    #stepAdjust .include-roadtax {
      float: right;
      margin: 0;
    }

    #stepAdjust .provider-img {
      width: 100%;
      margin-bottom: 10px;
    }

    #stepPayment h2 {
      margin-top: 0;
      font-weight: bold;
    }

    #stepPayment table.info td {
      vertical-align: top;
      padding: 2px 4px;
    }

    #stepPayment table.info {
      width: 100%;
    }

    #stepPayment table.info td:first-child {
      width: 180px;
      font-weight: 700;
    }

    #stepPayment table.info td:nth-child(2) {
      width: 15px;
    }

    #stepPayment .order {
      position: relative;
      text-align: left;
    }

    #stepPayment .status {
      font-weight: 700;
      font-size: 18px;
    }

    #stepPayment .print {
      padding: 5px 10px 4px;
      background-color: #fff;
      border: 1px solid #ccc;
      cursor: pointer;
      display: inline-block;
      float: right;
    }

    #stepPayment .date {
      position: absolute;
      top: 0;
      right: 0;
      text-align: right;
    }

    #stepPayment .info-wrapper {
      padding: 20px;
      margin: 20px 0;
      border-radius: 20px;
      background-color: #fff;
      text-align: left;
    }

    #stepPayment .info-wrapper h4 {
      font-weight: 700;
      margin: 0 0 10px;
    }

    #stepPayment .order table.items {
      width: 100%;
    }

    #stepPayment .order table.items td {
      padding: 8px;
    }

    #stepPayment .order table.items thead td {
      border-bottom: 1px solid #e40001;
      font-weight: 700;
      padding: 0 8px 8px;
    }

    #stepPayment .order table.items tfoot td {
      border-top: 1px solid #e40001;
      padding: 8px 8px 0;
    }

    #stepPayment .order table.items tbody td {
      border: 0;
      vertical-align: top;
    }

    #stepPayment .order table.items tbody td ul {
      padding-left: 15px;
      margin: 0;
    }

    #stepPayment .order table.items tfoot .amount {
      font-size: 20px;
      font-weight: 700;
    }

    #stepPayment .order table.items td a.attached {
      display: inline-block;
      margin-left: 10px;
    }

    #stepPayment .order table.items td .text-line-through {
      margin-right: 5px;
    }

    #stepPayment .payment .pyt-status-epp .form {
      margin-top: 15px;
      padding-top: 15px;
      border-top: 1px solid #000;
    }

    #stepPayment .payment .bank-list {
      border-radius: 10px;
      width: 100%;
    }

    #stepPayment .payment .bank-list .dropdown-toggle {
      border-radius: 10px;
      padding: 10px 15px;
      border: 1px solid #9e9e9e;
      background-color: #fff;
      outline: none !important;
      color: #000;
      font-weight: bold;
    }

    #stepPayment .payment .bank-list .dropdown-menu li {
      border-top: 1px solid #ddd;
    }

    #stepPayment .payment .bank-list .dropdown-menu li.disabled>* {
      opacity: 0.3;
    }

    #stepPayment .payment .bank {
      overflow: hidden;
    }

    #stepPayment .payment .bank img {
      width: 130px;
      height: auto;
      margin: 5px 10px 5px 0;
    }

    #stepPayment .payment .bank span {
      font-weight: 700;
    }

    #stepPayment .bank-option {
      width: 100%;
      display: flex;
      border: 1px solid #9e9e9e;
      padding: 10px 0;
      border-radius: 10px;
      margin-bottom: 10px;
      align-items: center;
      gap: 12px;
    }

    #stepPayment .bank-option input[type="radio"] {
      margin-left: 10px;
      margin-right: 10px;
    }

    #stepPayment .bank-option .bank {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    #stepPayment .bank-option .bank img {
      margin-left: 6px;
      margin-top: -2px;
    }

    #stepPayment .payment-action {
      display: flex;
      width: 100%;
      justify-content: space-between;
      gap: 20px;
      align-items: center;
      flex-wrap: wrap;
    }

    #stepPayment .payment-action__logos {
      text-align: left;
      flex: 1 1 auto;
      padding-top: 30px;
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      align-items: center;
    }

    #stepPayment .payment-action__cta {
      text-align: right;
      flex: 0 0 auto;
    }

    .tnc-refund-table {
      margin: 0 auto;
      width: 380px;
      overflow-x: auto;
    }

    #stepPayment .pyt-methods-wrapper {
      display: flex;
    }

    #stepPayment .pyt-methods-selection.nav-stacked {
      width: 32%;
    }

    #stepPayment .pyt-methods-content {
      padding: 15px;
      border: 1px solid #e4001c;
      width: 68%;
      display: inline-block;
    }

    #stepPayment .pyt-methods-selection.nav-tabs {
      display: none;
      position: relative;
      border: 0;
      white-space: nowrap;
    }

    #stepPayment .pyt-methods-selection.nav-tabs li {
      text-align: center;
      display: inline-block;
      width: calc(100% / 4);
    }

    #stepPayment .pyt-methods-selection li a {
      padding: 10px 8px;
    }

    #stepPayment .pyt-methods-selection li a label {
      margin: 0;
    }

    #stepPayment .pyt-methods-selection.nav-stacked li a {
      border-radius: 5px 0 0 5px;
      font-size: 13px;
      padding: 16px 10px;
    }

    #stepPayment .pyt-methods-selection.nav-stacked li a .fa:first-child {
      margin-right: 8px;
    }

    #stepPayment .pyt-methods-selection li a .fa-spin {
      margin-left: 5px;
    }

    #stepPayment .pyt-methods-selection.nav-tabs li a {
      border-radius: 5px 5px 0 0;
    }

    #stepPayment .pyt-methods-selection li.active a {
      color: #fff;
      background-color: #e4001c !important;
      font-weight: 700;
    }

    #radio-select {
      width: 100%;
      display: flex;
      border: 1px solid #9E9E9E;
      padding: 10px 0;
      border-radius: 10px;
      margin-bottom: 10px;
      align-items: center;
    }

    #stepPayment .pyt-methods-content .radio-select>* {
      margin-left: 15px;
    }

    #stepPayment .pyt-methods-content .radio-select input[type="radio"]:disabled~* {
      opacity: 0.3;
    }

    #stepPayment .pyt-methods-content .radio-select img {
      width: 120px;
      height: auto;
    }

    #stepPayment .pyt-methods-content .bank-list .dropdown-toggle:not(.bs-placeholder) {
      border-color: #e4001c;
    }

    #ob .tnc {
      cursor: pointer;
    }

    #cc img.accepted {
      width: 100px;
      height: auto;
    }

    #cc img.accepted {
      margin: 15px 15px 15px 0;
    }

    #clpsDelivery textarea {
      height: 150px;
      resize: none;
      margin: 0 0 10px;
    }

    #clpsDelivery .checkbox {
      margin-top: 0;
    }

    #clpsOwner textarea {
      resize: none;
      height: 100px;
    }

    #clpsExtraDriver .driver {
      background-color: #da1e00;
      color: #fff;
      padding: 4px 25px 3px 8px;
      display: inline-block;
      border-radius: 5px;
      max-width: 150px;
      margin: 0 13px 8px 0;
    }

    #clpsExtraDriver span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    }

    #clpsExtraDriver i.remove {
      float: right;
      margin: -19px;
      font-size: 17px;
      cursor: pointer;
    }

    #duitnow .payment-logos {
      position: relative;
      overflow: hidden;
    }

    #duitnow .payment-logos img {
      margin: 10px 10px 0 0;
      display: inline-block;
      height: 50px;
      width: auto;
    }

    #duitnow .qr-frame {
      background: #ED2E67;
      width: 280px;
      height: 300px;
      padding: 13px;
      border-radius: 12px;
      margin: 0 0 10px;
    }

    #duitnow .qr-frame .qr-bg {
      background: #fff;
      border-radius: 10px;
      height: 250px;
      padding: 25px;
      position: relative;
      overflow: hidden;
    }

    #duitnow .qr-frame .qr-bg .qr-img {
      height: calc(100% - 50px);
      width: calc(100% - 50px);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 25px;
      top: 25px;
      z-index: 1;

    }

    #duitnow .qr-frame .qr-bg .qr-refresh {
      position: absolute;
      top: calc(50% - 43px);
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }

    #duitnow .qr-frame .qr-bg .qr-refresh i {
      font-size: 50px;
    }

    #duitnow .qr-frame .qr-title {
      font-family: 'gothamrnd-bold';
      font-size: 12px;
      padding: 10px 0;
      color: #fff;
      text-align: center;
    }



    @media screen and (max-width: 767px) {
      #stepPayment .pyt-methods-wrapper {
        display: block;
      }

      #stepPayment .pyt-methods-selection.nav-stacked {
        display: none;
      }

      #stepPayment .pyt-methods-content {
        width: 100%;
      }

      #stepPayment .pyt-methods-selection.nav-tabs {
        display: block;
      }

      #stepPayment .pyt-methods-selection.nav-tabs li {
        width: auto;
        float: none;
      }

      #stepPayment .payment .bank img {
        display: block;
      }

      #stepPayment .bank-option {
        flex-direction: column;
        align-items: flex-start;
      }

      #stepPayment .bank-option input[type="radio"] {
        margin: 0 0 8px 10px;
      }

      #stepPayment .payment-action {
        flex-direction: column;
        align-items: stretch;
      }

      #stepPayment .bank-option .bank {
        width: 100%;
        padding-left: 6px;
      }

      #stepPayment .bank-option .bank img {
        margin-left: 0;
        margin-top: -6px;
      }

      #stepPayment .payment-action__logos,
      #stepPayment .payment-action__cta {
        padding-top: 10px;
        text-align: left;
      }

      #stepPayment .payment-action__cta {
        width: 100%;
      }

      .ant-tabs-top>.ant-tabs-nav .ant-tabs-nav-wrap {
        justify-content: flex-start;
        overflow-x: auto;
      }

      .ant-tabs-top>.ant-tabs-nav {
        margin: 0 0 16px;
      }

      .ant-tabs-top>.ant-tabs-nav .ant-tabs-nav-list {
        width: 100%;
        display: flex;
        gap: 8px;
      }

      .ant-tabs-top>.ant-tabs-nav .ant-tabs-tab {
        flex: 1 1 auto;
        justify-content: center;
      }
    }

    #order .print-frame {
      display: none;
    }



    .qr-container {
      position: relative;
      width: 300px;
      margin: 50px auto;
    }

    .qr-container img {
      width: 100%;
      display: block;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 20px;
    }

    button {
      height: 45px;
      margin-top: 15px;
      padding: 8px 25px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      /* background: linear-gradient(135deg, #4caf50, #81c784); */
      background: #e4001c;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
      transition: background 0.3s, transform 0.2s;
    }

    button:hover {
      /* background: linear-gradient(135deg, #43a047, #66bb6a); */
      background: #e4001c;
      transform: scale(1.05);
    }

    button:active {
      transform: scale(0.98);
    }

    .header-container {
      max-width: 1250px;
    }

    .wide-container {
      max-width: 1300px;
      /* or 100% or any desired value */
    }
  </style>

</head>

<div class="container wide-container">
  <ngx-spinner type="square-jelly-box">
    <p style="color: white"><strong> Loading... </strong></p>
  </ngx-spinner>
  <div id="header" class="nav-bar-top">
    <nav class="navbar">

      <a href="https://bmsroadtax.com/"> <img class="logo" src="assets/img/bms-eplateform-logo.png"></a>
      <ul class="nav-links">
        <input type="checkbox" id="checkbox_toggle">
        <label for="checkbox_toggle" class="hamburger">&#9776;</label>
        <div class="menu">
          <li class="nav-item">
            <a href="tel:1300885755" class="nav-link hotline"><img src="assets/img/payment/tel.svg"> 1300 88 5755</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://bmsroadtax.com/">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://bmsroadtax.com/index2.html#about">About Us</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://bmsroadtax.com/index2.html#contacts">Towing Hotlines</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://bmsroadtax.com/index2.html#claim">Customer Support</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://bmsroadtax.com/index2.html#news">Helpful Info</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://bmsroadtax.com/index2.html#outlets">BMS Outlets</a>
          </li>
        </div>
      </ul>
    </nav>
  </div>
</div>
<div class="tab-pane active" role="tabpanel" id="stepPayment">

  <div class="tab-pane-content bg-grey">
    <div class="container">
      <div class="print" *ngIf="this.invoiceModel.status=='PAID'" (click)="downloadReceipt()"><i
          class="fa fa-print"></i> PRINT</div>
      <br />
    </div>
    <br />
    <div class="container text-left">
      <div class="order">
        <h2>INVOICE</h2>
        <div class="date">{{this.invoiceModel.createdDate}}<br><span [ngClass]="{
    'status text-success': invoiceModel.status === 'PAID',
    'status text-danger': invoiceModel.status !== 'PAID'
  }">{{this.invoiceModel.status}}</span></div>
        <table class="info">
          <tbody>
            <tr>
              <td>Order No.</td>
              <td>:</td>
              <td>{{this.invoiceModel.orderNo}}</td>
            </tr>
            <tr>
              <td>Vehicle No.</td>
              <td>:</td>
              <td>{{this.invoiceModel.registrationNo}}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>:</td>
              <td>{{this.invoiceModel.name}}</td>
            </tr>

            <tr>
              <td>Contact No.</td>
              <td>:</td>
              <td>{{this.invoiceModel.contactNo1}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>:</td>
              <td>{{this.invoiceModel.email}}</td>
            </tr>
            <tr *ngIf="this.invoiceModel.type !='RoadTax'">
              <td>Address</td>
              <td>:</td>
              
              <td>{{this.invoiceModel.address}}<label style="font-weight: bold;color: red;" *ngIf="this.invoiceModel.deliveryRequired && this.invoiceModel.deliveryAddress ==''">(Deliver to same address)</label></td>
            </tr>
            <tr *ngIf="this.invoiceModel.deliveryAddress !=''">
              <td>Delivery Address</td>
              <td>:</td>
              <td>{{this.invoiceModel.deliveryAddress}}</td>
            </tr>

          </tbody>
        </table>
        <br />
        <div *ngIf="this.invoiceModel.customerRemark != '' && this.invoiceModel.customerRemark != undefined">
          <h4 class="text-danger"><b>*** Customer Remark ***</b></h4>
          <h4 class="text-danger">{{this.invoiceModel.customerRemark}}</h4>
        </div>

        <div class="info-wrapper">
          <table class="items">
            <thead>
              <tr>
                <td style="width:50px;">No.</td>
                <td>Description</td>
                <td class="text-right" style="width:120px;">Amount (RM)</td>
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let item of this.invoiceModel.invoiceDetails;let i = index">
                <td>{{i + 1}}</td>
                <td>{{item.description}}</td>
                <td class="text-right"><span class="">{{item.total  | number:'1.2-2'}}</span></td>
              </tr>

            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" style="font-weight: 700;font-size: 20px;" class="text-right">Total</td>
                <td class="text-right amount">{{this.invoiceModel.total | number:'1.2-2'}}</td>
              </tr>
            </tfoot>

          </table>
                     <strong style="font-size: 10px;"> {{getAgencyName()}}</strong>
        </div>
      </div>



      <div class="payment">

        <div class="pyt-status info-wrapper" *ngIf="this.invoiceModel.invoicePayment?.length > 0">
          <h4><i class="fa fa-credit-card"></i> Payment Details</h4>
          <div *ngFor="let payment of invoiceModel.invoicePayment">
            <table class="info">
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>:</td>
                  <td><span
                      [ngClass]="payment.transactionStatus  === 'Success' ? 'text-success' : 'text-danger'">{{payment.transactionStatus }}</span>
                  </td>
                </tr>
                <tr>
                  <td>Date</td>
                  <td>:</td>
                  <td>{{payment.transactionTime}}</td>
                </tr>
                <tr>
                  <td>Transaction ID</td>
                  <td>:</td>
                  <td>{{payment.transactionId}}</td>
                </tr>
                <tr>
                  <td>Seller Order No</td>
                  <td>:</td>
                  <td>{{payment.sellerOrderNo}}</td>
                </tr>
                <tr>
                  <td>Buyer Bank Name</td>
                  <td>:</td>
                  <td>{{payment.bankName}}</td>
                </tr>
                <tr>
                  <td>Amount</td>
                  <td>:</td>
                  <td>{{payment.transactionAmount | currency :'RM ':'symbol':'1.2-2'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="pyt-methods info-wrapper" *ngIf="this.invoiceModel.status != 'PAID'">

          <h4><b>PAY NOW AND GET COVERED!</b></h4>
          <form [formGroup]="form" autocomplete="off">
            <nz-tabset [nzTabPosition]="tabPosition" (nzSelectedIndexChange)="onTabChange($event)">
              <nz-tab nzTitle="FPX">
                <label class="bank-option">
                  <input formControlName="mbb" [disabled]="isMbbDisabled" type="radio"
                    (click)="onBankClick('MB2U0227')">
                  <div class="bank">
                    <img src="assets/img/payment/MB2U0227.png">
                    <span>Maybank2u</span>
                  </div>
                </label>
                <label class="bank-option">
                  <input formControlName="pbb" [disabled]="isPbbDisabled" type="radio" (click)="onBankClick('PBB0233')">
                  <div class="bank">
                    <img src="assets/img/payment/PBB0233.png">
                    <span>Public Bank</span>
                  </div>
                </label>
                <nz-select nzShowSearch formControlName="bank" class="form-control"
                  (ngModelChange)="onBankChange($event)" [nzShowArrow]="true" nzBorderless
                  nzPlaceHolder="More Bank Available for Selection"
                  [ngClass]="{'is-invalid': submitted &&  f.bank.errors }">
                  <nz-option *ngFor="let item of bankList" nzCustomContent
                    [nzLabel]="item.value + (item.isOffline ? ' (Offline)' : '')" [nzValue]="item.key"
                    [nzDisabled]="item.isOffline">
                    <img src="{{ 'assets/img/payment/'+item.key+'.png' }}" width="130px" style="margin-right: 10px;">
                    {{ item.value + (item.isOffline ? ' (Offline)' : '')}}
                  </nz-option>
                </nz-select>
                <br />
                <div class="payment-action">
                  <div class="payment-action__logos">
                    <img width="150px" src="assets/img/payment/fpx-logo.png">
                  </div>
                  <div class="payment-action__cta">
                    <label class="tnc"><input type="checkbox" formControlName="isChecked" name="paymentTnc"> I agree to
                      FPX's <a href="https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp" target="_black"><i
                          class="text-primary">Terms and Conditions</i></a>.</label>
                    <br />
                    <button type='button' (click)="fpxPayment()" class="btn btn-primary">Pay</button>
                  </div>
                </div>


              </nz-tab>
              <nz-tab *ngIf="this.allowHlbCreditcard()" nzTitle="Credit/Debit Card">
                <div>
                  YOU ARE 100% SECURE!

                  We do not store credit card information. We take credit card data security very seriously, and we do
                  not
                  have access to your credit card information.
                  <div class="payment-action">
                    <div class="payment-action__logos">
                      <img width="80px" src="assets/img/payment/mastercard.png">
                      <img width="120px" src="assets/img/payment/visa.png">
                    </div>
                    <div class="payment-action__cta">
                      <br />

                      <button type='button' (click)="creditCardPayment()" class="btn btn-primary">Pay</button>
                    </div>
                  </div>
                </div>
              </nz-tab>
              <nz-tab *ngIf="this.allowMbbQr()" nzTitle="Duit Now QR">
                <div id="duitnow">

                  <p>Scan and pay from any mobile banking or eWallet.</p>
                  <div class="qr-frame">
                    <div class="qr-bg">

                      <div class="qr-img" *ngIf="!this.showOverlay">
                        <img src="{{qrBase64}}" alt="QR Code" width="210px">

                      </div>
                      <div class="qr-refresh" *ngIf="this.showOverlay">
                        <button (click)="getMbbQr()">GET QR CODE</button>
                      </div>

                    </div>
                    <div class="qr-title">MALAYSIA NATIONAL QR</div>
                  </div>
                  <p *ngIf="!this.showOverlay" class="qr-countdown">QR Code expire in <b>{{countdownValue }}</b>
                    seconds.
                  </p>

                  <br />
                  <div>
                    <img width="120px" style="margin-right: 10px" src="assets/img/payment/boost.png">
                    <img width="50px" style="margin-right: 10px" src="assets/img/payment/duit-now-logo.png">
                    <img width="120px" style="margin-right: 10px" src="assets/img/payment/grabpay.jpg">
                    <img width="95px" style="margin-right: 10px" src="assets/img/payment/MAE-black.png">
                    <img width="120px" style="margin-right: 10px" src="assets/img/payment/shopeepay.png">
                    <img width="120px" style="margin-right: 10px" src="assets/img/payment/tng.png">

                  </div>
                </div>
              </nz-tab>
              <nz-tab *ngIf="this.allowHlbEpp()" nzTitle="Credit Card Easy Payment Plan (EPP)">
                <strong>Available Plans:</strong>
                <nz-select class="form-control" nzBorderless nzShowSearch [nzShowArrow]="true" formControlName="epp"
                  nzPlaceHolder="Please select a plan">
                  <nz-option nzValue="1" nzLabel="Hong Leong Bank - 6 Months"></nz-option>
                  <nz-option *ngIf="this.allowHlb12MonthsEpp()" nzValue="2" nzLabel="Hong Leong Bank - 12 Months">
                  </nz-option>
                </nz-select>
                <div class="payment-action">
                  <div class="payment-action__logos">
                    <img width="80px" src="assets/img/payment/mastercard.png">
                    <img width="120px" src="assets/img/payment/visa.png">
                  </div>
                  <div class="payment-action__cta">
                    <br />

                    <button type='button' (click)="eppPayment()" class="btn btn-primary">Pay</button>
                  </div>
                </div>
              </nz-tab>

            </nz-tabset>
          </form>
        </div>
      </div>

      <div class="tnc-order info-wrapper" style="font-size: 10px">
        <h4><b>TERMS AND CONDITIONS</b></h4>
        By proceeding with this transaction, you acknowledge that you have read, understood, and agreed to the following
        terms and conditions.
        <br>

        <br>
        <label *ngIf="!isChubbSelected()">1. When we process your insurance application, you
          will be asked certain questions relating to your personal
          circumstances. We may also request additional information in order to provide a competitive quote that aligns
          with your situation and requirements. Please note that the rates we offer are subject to change as determined
          by
          the insurance company underwriting your policy. As such, we do not have control over any adjustments imposed
          by
          the insurer. The rate provided is considered current at the time of your application. Any subsequent changes
          will be communicated to you without limitation.</label>

        <label *ngIf="isChubbSelected()">1. You may cancel your policy at any time by giving us a written notice and are
          entitled to a partial refund of the premium, if no claim was incurred prior to cancellation. There will not be
          any refund of premium for any cancellation of your policy if Chubb has been on risk for more than eight (8)
          months or you have paid the Minimum Premium only.
        </label>
        <br>
        <label>2. For cancellation and refund requests, please note that a 1.5% cancellation fee will be deducted from the refund amount for payments made via credit/debit card.</label>
        <br>
        <label>3. Once road tax has been processed, no refund can be issued.</label>
        <br>
        <label>4. For road tax refund due to policy cancellation or transfer ownership, customer needs to visit JPJ
          branch and
          request for refund.</label>
        <br>
        <label>5. In accordance with Insurance Act 1996 (Part XII, Section 141 Assumption of Risks, Subsection 4) all
          refund
          premium shall be paid directly to the policyholder.</label>
        <br>
        <label>6. Should you decide to cancel the policy, you will receive a premium refund as per the policy
          condition(s) in accordance with the insurance company&#39;s Customer Charter. The premium refund scale is as
          follows subject to minimum premium.</label>
        <div class="tnc-refund-table">
          <table style='border-collapse: collapse; font-size: 9px; border: 1px solid black'>
            <tr>
              <td style="font-weight: bold; text-align: center; border: 1px solid black; min-width:80px">Period of
                Insurance </td>
              <td style="font-weight: bold; text-align: center; border: 1px solid black; min-width: 80px ">Refund of
                Premium </td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Not exceeding 1 week</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">87.5% of the total premium</td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Not exceeding 1 month</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">75.0% of the total Premium</td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Not exceeding 2 months</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">62.5% of the total premium</td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Not exceeding 3 months</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">50.0% of the total premium</td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Not exceeding 4 months</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">37.5% of the total premium</td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Not exceeding 6 months</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">25.0% of the total premium</td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Not exceeding 8 months</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">12.5% of the total premium</td>
            </tr>
            <tr>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">Exceeding 8 months</td>
              <td style="text-align: center; border: 1px solid black; min-width: 180px ">No refund of premium allowed
              </td>
            </tr>
          </table>
        </div>

        @if(this.isTuneSelected())
        {
          <label>7. For Product enquiry, claim matters or complaint, please contact us via any of the following channels:
            Call us at 1300-88-575 or email Us at <a href="mailto:myegkiosks@gmail.com"
              style="color: blue;">myegkiosks&#64;gmail.com</a>.</label>
        }@else{
          <label>7. For cancellation and/or refund requests, please refer to our Cancellation and Refund Policy available in your Policy Wording. If you require further asistenace, please contact our customer
            care team at 1300-88-575 or email Us at <a href="mailto:myegkiosks@gmail.com"
              style="color: blue;">myegkiosks&#64;gmail.com</a>.
            </label>
        }
        <label *ngIf="isTuneSelected()">8. No free Look Period </label>
        <label *ngIf="isZurichSelected()">8. Free Look Period <br /><br />

          <strong>Only Cancellation Refund applicable</strong><br />

          Should you decide to cancel the policy/certificate before the expiry date, you will receive a
          premium/contribution refund. Please refer to the policy wording (provide link) for the premium/contribution
          refund scale.<br />
        </label>
        <label *ngIf="isTuneSelected()">8. Consumers have an option to purchase similar product with a rebate on commission or is commission-free
          if purchased directly from TIMB’s own website or physical branches prior to proceeding with final confirmation
          of purchase</label>
        <br>
      </div>
    </div>
  </div>
</div>
<div id="footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-4">
        <span class="copyright">© 2025 BMS ROADTAX E PLATFORM 202403148877 (KT0570731-V). All Rights Reserved</span>
      </div>
      <div class="text-center col-sm-4">

        <a (click)="showModal('privacyPolicy')">Privacy Policy</a>
      </div>
      <div class="col-sm-4">
        <div class="social-links">
          <a href="https://www.facebook.com/BrilliantManagementServices" target="_blank">
            <i class="fa fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/bmsroadtax" target="_blank">
            <i class="fa fa-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/company/14707674" target="_blank">
            <i class="fa fa-linkedin"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCSQnLzjnP3CyFk-4zPq85Yg" target="_blank">
            <i class="fa fa-youtube-play"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<nz-modal [nzCancelText]="null" [(nzVisible)]="isVisible" [nzTitle]="modalTitle" (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <p>{{line1}}</p>
  </ng-container>
</nz-modal>